import { FeatureFlagsFragment, useMyFeatureFlagsQuery } from "apps/web/src/types";

interface useHasFeatureOptions {
  skip?: boolean;
}

export const useHasFeature = (flag: keyof FeatureFlagsFragment, opts?: useHasFeatureOptions) => {
  const skip = opts?.skip ?? false;
  const { data } = useMyFeatureFlagsQuery({
    skip,
  });

  return Boolean(data && data.myFeatureFlags[flag]);
};

export const useHasFeatureWithLoading = (flag: keyof FeatureFlagsFragment, opts?: useHasFeatureOptions) => {
  const skip = opts?.skip ?? false;
  const { data, loading } = useMyFeatureFlagsQuery({
    skip,
  });
  const value = Boolean(data && data.myFeatureFlags[flag]);
  return { value, loading };
};
